/* eslint-disable no-unused-vars */
import { devLog } from '@/utils/dev';
import type { TAnalytics } from '@/containers/AnalyticsContainer/types';

declare global {
  interface Window {
    clarity?: any;
  }
}

export const CLARITY_PROJECT_ID = process.env.NEXT_PUBLIC_CLARITY_ID;

export const logClarityEvent = <K extends keyof TAnalytics>(
  event: K,
  ...params: TAnalytics[K] extends undefined | null
    ? [undefined?]
    : [TAnalytics[K]]
) => {
  const [data] = params;
  if (typeof window !== 'undefined' && window.clarity) {
    try {
      // We can't send object to clarity and we should convert it to string
      const eventValue = data ? JSON.stringify(data) : undefined;
      // Set Up Clarity Event Tracking With JavaScript
      if (eventValue) window.clarity('set', 'event_parameters', eventValue);
      window.clarity('event', event);
    } catch (error) {
      devLog(error);
    }
  }
};
